import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { sendEvent } from '../../shared/search-event';
import ErrorBoundary from '../../shared/error-boundary';
import Callout from '../../shared/callout';
import { setLocationHash } from '../../shared/location';
import breakpoints from '../../shared/breakpoints';

const FilterDescriptions = {
  wires: 'Wires',
  contributors: 'Contributors',
  keywords: 'Keywords',
  'stock-codes': 'Stock Codes',
};

function getFilterTypeDescription(filterType) {
  return FilterDescriptions[filterType];
}

export default class SearchFilter extends React.Component {
  /* eslint-disable react/no-unused-prop-types */
  static propTypes = {
    hasWires: PropTypes.bool.isRequired,
    hasContributors: PropTypes.bool.isRequired,
    hasKeywords: PropTypes.bool.isRequired,
    hasStockCodes: PropTypes.bool.isRequired,
  }
  /* eslint-enable react/no-unused-prop-types */

  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedFilter: null,
      presented: false,
    };

    _.some(FilterDescriptions, (desc, key) => {
      const test = props[`has${desc.replace(' ', '')}`];
      if (test) {
        this.state.selectedFilter = key;
      }
      return test;
    });
  }

  componentDidMount() {
    $(document).on('mouseup.searchFilter', e => {
      if (breakpoints.getScreenSize() === 'small') return;

      const $target = $(e.target);

      if ($target.parents('.search-results-search-filter').length) return;

      this.setState({
        presented: false,
      });
    });

    if (this.state.selectedFilter) {
      this.setFilter(null, this.state.selectedFilter);
    }

    (async () => sendEvent())();
  }

  componentWillUnmount() {
    $(document).off('mouseup.searchFilter');
  }

  setFilter(e, filterType) {
    if (e && e.preventDefault) e.preventDefault();

    this.setState({
      selectedFilter: filterType,
      presented: false,
    });
    setLocationHash(`#nav-${filterType}`);
  }

  togglePresented() {
    this.setState(state => ({
      presented: !state.presented,
    }));
  }

  render() {
    return (
      <ErrorBoundary>
        {!!this.state.selectedFilter && (
          <div className="search-results-search-filter">
            <span className="search-results-search-filter-label">
              Search Livewire by&nbsp;
            </span>
            <Callout
              indicatorPosition="top-right"
              offsetX={0}
              offsetY={0}
              size="medium"
              calloutTrigger={(
                <span className="search-results-search-filter-trigger-filter-type">
                  <span className="search-results-search-filter-trigger-filter-type-description">{getFilterTypeDescription(this.state.selectedFilter)}</span>
                  <span className="fa fa-caret-down" />
                </span>
)}
              show={this.state.presented}
              togglePresent={() => this.togglePresented()}
              classModifier="btn btn-link"
            >
              <div className="callout-inner-body">
                <section>
                  <h3>Select content type</h3>
                  <ul>
                    {_.map(FilterDescriptions, (desc, key) => (this.props[`has${desc.replace(' ', '')}`]
                      ? <li key={key}><a href="#" onClick={e => this.setFilter(e, key)}>{desc}</a></li>
                      : null
                    ))}
                  </ul>
                </section>
              </div>
            </Callout>
          </div>
        )}
      </ErrorBoundary>
    );
  }
}
